<div class="container">
    <div class="text-center m-5">
        <h1>Analisi Reverse M45</h1>
    </div>
    <div class="row">
        <div class="col-6">
            <form [formGroup]="formFiltri">
                <div class="filtri">
                    <div class="row titolofiltri p-2">
                        <div class="col-12 text-center">
                            <h3>Filtri</h3>
                        </div>
                    </div>
                    <div class="row m-2">
                        <div class="col-6">
                            Mercato
                        </div>
                        <div class="col-6">
                            <mdb-form-control>
                                <mdb-select formControlName="selMarket" id="mercato">
                                    <mdb-option *ngFor="let m of markets" (click)="selectMarket()" [value]="m.market">{{
                                        m.market
                                        }}</mdb-option>
                                </mdb-select>
                                <label mdbLabel for="mercato" class="form-label">Seleziona il mercato</label>
                            </mdb-form-control>
                        </div>
                    </div>
                    <div class="row m-2">
                        <div class="col-6">
                            Minuto dell'ora
                        </div>
                        <div class="col-6">
                            <mdb-form-control>
                                <mdb-select formControlName="selMinuto">
                                    <mdb-option *ngFor="let m of minuti" [value]="m"
                                        (click)="selectMarket()">{{m}}</mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Seleziona il minuto</label>
                            </mdb-form-control>
                        </div>
                    </div>
                    <div class="row m-2">
                        <div class="col-6">
                            Chiusura dopo ore
                        </div>
                        <div class="col-6">
                            <mdb-form-control>
                                <mdb-select formControlName="selOraclose">
                                    <mdb-option *ngFor="let m of ora" [value]="m"
                                        (click)="selectMarket()">{{m}}</mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Seleziona ora close</label>
                            </mdb-form-control>
                        </div>
                    </div>
                    <div class="row m-2">
                        <div class="col-6">
                            Giorno della settimana
                        </div>
                        <div class="col-6">
                            <mdb-form-control>
                                <mdb-select formControlName="selGiorno">
                                    <mdb-option *ngFor="let g of giorni" [value]="g.id">{{
                                        g.giorno
                                        }}</mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Seleziona il giorno</label>
                            </mdb-form-control>
                        </div>
                    </div>
                    <div class="row m-2">
                        <div class="col-6">
                            Ampiezza minima O-C
                        </div>
                        <div class="col-6">
                            <mdb-form-control>
                                <input mdbInput type="text" id="ampiezzaOC" formControlName="ampiezzaOC"
                                    class="form-control text-end" />
                                <label mdbLabel class="form-label" for="ampiezzaOC">Punti (intero)</label>
                            </mdb-form-control>
                        </div>
                    </div>
                    <div class="row m-2">
                        <div class="col-6">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" formControlName="applicaSL" value=""
                                    id="flexCheckDefault" />
                                <label class="form-check-label" for="flexCheckDefault">Applica SL</label>
                            </div>
                        </div>
                        <div class="col-6">
                            <mdb-form-control>
                                <input mdbInput type="text" id="sl" formControlName="sl"
                                    class="form-control text-end" />
                                <label mdbLabel for="sl" class="form-label" for="sl">Stop Loss (punti)</label>
                            </mdb-form-control>
                        </div>
                    </div>
                    <div class="row m-2">
                        <div class="col-6">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" formControlName="applicaTP" value=""
                                    id="flexCheckDefault" />
                                <label class="form-check-label" for="flexCheckDefault">Applica TP</label>
                            </div>
                        </div>
                        <div class="col-6">
                            <mdb-form-control>
                                <input mdbInput type="text" id="tp" formControlName="tp"
                                    class="form-control text-end" />
                                <label mdbLabel class="form-label" for="tp">Take Profit (punti)</label>
                            </mdb-form-control>
                        </div>
                    </div>
                    <div class="row m-5">
                        <div class="col-6">
                            <div *ngIf="loading" class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Elaborazione in corso...</span>
                            </div>
                        </div>
                        <div class="col-6 text-end">
                            <button type="button" class="btn btn-primary" (click)="filtra()">aPPLICA FiltrI</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-6">
            <div class="datiSommario">
                <div class="row titolosommario p-2">
                    <div class="col-12 text-center">
                        <h3>Mercato {{mercato}} ({{spread}})</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6"></div>
                    <div class="col-2 text-end">
                        Buy
                    </div>
                    <div class="col-2 text-end">
                        Sell
                    </div>
                    <div class="col-2 text-end">
                        Totale
                    </div>
                </div>
                <div class="row" style="padding: 5px;">
                    <div class="col-6">
                        Numero Operazioni
                    </div>
                    <div class="col-2 text-end">
                        {{numopbuy}}
                    </div>
                    <div class="col-2 text-end">
                        {{numopsell}}
                    </div>
                    <div class="col-2 text-end">
                        {{numop}}
                    </div>
                </div>
                <div class="row" style="padding: 5px;">
                    <div class="col-6">
                        Numero Operazioni Positive
                    </div>

                    <div class="col-2 text-end">
                        {{numopsbuy}}
                    </div>
                    <div class="col-2 text-end">
                        {{numopssell}}
                    </div>
                    <div class="col-2 text-end">
                        {{numops}}
                    </div>
                </div>
                <div class="row" style="padding: 5px;">
                    <div class="col-6">
                        Percentuale Operazioni Positive
                    </div>
                    <div class="col-2 text-end">
                        {{perposbuy| number: '1.2-2'}}%
                    </div>
                    <div class="col-2 text-end">
                        {{perpossell| number: '1.2-2'}}%
                    </div>
                    <div class="col-2 text-end">
                        {{perpos| number: '1.2-2'}}%
                    </div>
                </div>
                <div class="row" style="padding: 5px;">
                    <div class="col-6">
                        Punti Totali
                    </div>
                    <div class="col-2 text-end">
                        {{ptotbuy| number: '1.1-1'}}
                    </div>
                    <div class="col-2 text-end">
                        {{ptotsell| number: '1.1-1'}}
                    </div>
                    <div class="col-2 text-end">
                        {{ptot| number: '1.1-1'}}
                    </div>

                </div>
                <div class="row" style="padding: 5px;">
                    <div class="col-6">
                        Punti per Operazione
                    </div>
                    <div class="col-2 text-end">
                        {{ppopbuy| number: '1.2-4'}}
                    </div>
                    <div class="col-2 text-end">
                        {{ppopsell| number: '1.2-4'}}
                    </div>
                    <div class="col-2 text-end">
                        {{ppop| number: '1.2-4'}}
                    </div>
                </div>

                <div class="row" style="padding: 5px;">
                    <div class="col-6">
                        Max Profit
                    </div>
                    <div class="col-2 text-end">
                        {{maxprofitbuy| number: '1.2-4'}}
                    </div>
                    <div class="col-2 text-end">
                        {{maxprofitsell| number: '1.2-4'}}
                    </div>
                    <div class="col-2 text-end">
                        {{maxprofit| number: '1.2-4'}}
                    </div>
                </div>

                <div class="row" style="padding: 5px;">
                    <div class="col-6">
                        Max Loss
                    </div>
                    <div class="col-2 text-end">
                        {{maxlossbuy| number: '1.2-4'}}
                    </div>
                    <div class="col-2 text-end">
                        {{maxlosssell| number: '1.2-4'}}
                    </div>
                    <div class="col-2 text-end">
                        {{maxloss| number: '1.2-4'}}
                    </div>
                </div>

                <div class="row" style="padding: 5px;">
                    <div class="col-6">
                        RAWAL
                    </div>
                    <div class="col-2 text-end">
                        {{rawalbuy| number: '1.2-4'}}
                    </div>
                    <div class="col-2 text-end">
                        {{rawalsell| number: '1.2-4'}}
                    </div>
                    <div class="col-2 text-end">
                        {{rawal| number: '1.2-4'}}
                    </div>
                </div>

                <div class="row" style="padding: 5px;">
                    <div class="col-6">
                        Kelly
                    </div>
                    <div class="col-2 text-end">
                        {{kellybuy| number: '1.2-4'}}
                    </div>
                    <div class="col-2 text-end">
                        {{kellysell| number: '1.2-4'}}
                    </div>
                    <div class="col-2 text-end">
                        {{kelly| number: '1.2-4'}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row m-5">
        <div class="col-3">
            <button type="button" class="btn btn-primary" (click)="graficoTotale()">grafico totale</button>
        </div>
        <div class="col-3">
            <button type="button" class="btn btn-primary" (click)="graficoBuy()">grafico buy</button>
        </div>
        <div class="col-3">
            <button type="button" class="btn btn-primary" (click)="graficoSell()">grafico sell</button>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
                [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-6">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor"
                [options]="chartOptionsOrari" [(update)]="updateFlag" [oneToOne]="oneToOneFlag"
                [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
        <div class="col-6">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor"
                [options]="chartOptionsPuntiOrari" [(update)]="updateFlag" [oneToOne]="oneToOneFlag"
                [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
    </div>

</div>